module.exports = __webpack_public_path__ + "img/live-not-started.49ad0b3a.svg";